import './index.scss';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PermissionChecker from '~/components/permission_checker';
import IconInput from '~/form_components/icon_input';
import TextInput from '~/form_components/text_input';
import useComponentVisible from '~/hooks/useComponentVisible';
import { useUser } from '~/providers/user';
import { SearchType } from '~/routes/content_library/providers/enums';
import Permissions from '~/settings/permissions';
import AdvancedSearchDialog from './advanced_search_dialog';
import SearchTypeRadioButton from './search_type_radio_button';
const SearchBar = () => {
    const { pathname, search: locationSearch } = useLocation();
    const { hasPermission, useNewView } = useUser();
    const navigate = useNavigate();
    const defaultSearchType = hasPermission(Permissions.SEARCH_DOCUMENTS)
        ? SearchType.Documents
        : hasPermission(Permissions.SEARCH_CLAUSES)
            ? SearchType.Clauses
            : '';
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const [searchText, setSearchText] = useState('');
    const [searchType, setSearchType] = useState(defaultSearchType);
    const [advancedFilters, setAdvancedFilters] = useState({});
    useEffect(() => {
        const searchParams = new URLSearchParams(locationSearch);
        const filtersString = searchParams.get('filters');
        if (filtersString) {
            const filters = JSON.parse(filtersString);
            setSearchText(filters.searchText ? filters.searchText : '');
            setSearchType(filters.searchType ? filters.searchType : defaultSearchType);
            setAdvancedFilters(filters.advancedFilters ? filters.advancedFilters : {});
        }
        else {
            setSearchText('');
            setSearchType(defaultSearchType);
            setAdvancedFilters({});
        }
    }, [locationSearch, defaultSearchType]);
    const triggerSearch = () => {
        if (!searchText && searchType === SearchType.Clauses) {
            return;
        }
        const searchParams = new URLSearchParams(locationSearch);
        const filters = {
            searchType,
        };
        if (searchText !== '') {
            filters.searchText = searchText;
        }
        if (Object.keys(advancedFilters).length > 0) {
            filters.advancedFilters = advancedFilters;
        }
        searchParams.set('filters', JSON.stringify(filters));
        if (pathname === '/content-library') {
            navigate({
                pathname,
                search: searchParams.toString(),
            });
        }
        else {
            navigate('/content-library?' + searchParams.toString());
        }
    };
    const clearFilters = () => {
        setSearchText('');
        setAdvancedFilters({});
    };
    const closeAdvancedSearch = () => {
        setIsComponentVisible(false);
    };
    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            triggerSearch();
        }
    };
    const dropdownIconClass = classnames('fas', {
        'fa-chevron-down': !isComponentVisible,
        'fa-chevron-up': isComponentVisible,
    });
    return (React.createElement(PermissionChecker, { requiredAnyPermissions: [Permissions.SEARCH_DOCUMENTS, Permissions.SEARCH_CLAUSES] },
        React.createElement("div", { className: 'search-bar', "data-testid": 'search-bar' },
            !useNewView &&
                React.createElement(SearchTypeRadioButton, { searchType: searchType, setSearchType: (searchT) => {
                        setAdvancedFilters({});
                        setSearchType(searchT);
                    } }),
            React.createElement("div", { className: 'search-input-container' },
                React.createElement(IconInput, { leftIcon: React.createElement("span", { className: 'fas fa-search' }), rightIcon: !useNewView
                        ? React.createElement("div", { "data-testid": 'search-activate-advanced-dialog', className: 'hover-pointer', onClick: () => setIsComponentVisible(!isComponentVisible) },
                            React.createElement("i", { className: dropdownIconClass }))
                        : React.createElement(React.Fragment, null) },
                    React.createElement(TextInput, { "data-testid": 'search-input-box', className: 'search-input-box', placeholder: useNewView ? 'Search Documents...' : 'Search library...', onChange: (e) => setSearchText(e.currentTarget.value), onKeyDown: (e) => handleOnKeyDown(e), value: searchText })),
                isComponentVisible &&
                    React.createElement(AdvancedSearchDialog, { ref: ref, search: triggerSearch, advancedFilters: advancedFilters, setAdvancedFilters: setAdvancedFilters, close: closeAdvancedSearch, searchType: searchType, clearFilters: clearFilters })))));
};
export default SearchBar;
